import styles from './prensa.module.css'

function Prensa() {
    return (
        <section id='prensa' className={styles.prensaMain}>
            <div className={styles.header}>
                <h3>Prensa & Medios</h3>
            </div>
            
            <div className={styles.linksPrensa}>
                <div className={styles.boxprensa}>
                    <div className={styles.quoteIcon}>&ldquo;</div>
                    <p>"El gran cantante argentino de tangos Lautaro Mazza, presenta un concierto didáctico para la Universidad de las Américas de Ecuador"</p>
                    <div className={styles.prensaFooter}>
                        <span className={styles.mediaName}>Ibermúsicas</span>
                        <a href="https://www.ibermusicas.org/index.php/el-gran-cantante-argentino-de-tangos-lautaro-mazza-presenta-un-concierto-didactico-para-la-universidad-de-las-americas-de-ecuador/" target='_blank' rel="noopener noreferrer">
                            Ver nota
                            <span className={styles.arrowIcon}>&rarr;</span>
                        </a>
                    </div>
                </div>

                <div className={styles.boxprensa}>
                    <div className={styles.quoteIcon}>&ldquo;</div>
                    <p>"Lautaro Mazza: tras brillar en el colon cierra el año de local"</p>
                    <div className={styles.prensaFooter}>
                        <span className={styles.mediaName}>El Día</span>
                        <a href="https://www.eldia.com/nota/2022-9-14-2-25-38-lautaro-mazza-tras-brillar-en-el-colon-cierra-el-ano-de-local-espectaculos" target='_blank' rel="noopener noreferrer">
                            Ver nota
                            <span className={styles.arrowIcon}>&rarr;</span>
                        </a>
                    </div>
                </div>

                <div className={styles.boxprensa}>
                    <div className={styles.quoteIcon}>&ldquo;</div>
                    <p>"Lautaro Mazza, otra voz para el tango"</p>
                    <div className={styles.prensaFooter}>
                        <span className={styles.mediaName}>Página 12</span>
                        <a href="https://www.pagina12.com.ar/226029-lautaro-mazza-otra-voz-para-el-tango" target='_blank' rel="noopener noreferrer">
                            Ver nota
                            <span className={styles.arrowIcon}>&rarr;</span>
                        </a>
                    </div>
                </div>

                <div className={styles.boxprensa}>
                    <div className={styles.videoIcon}>&#9654;</div>
                    <p>Entrevista de Victor Hugo Morales</p>
                    <div className={styles.prensaFooter}>
                        <span className={styles.mediaName}>YouTube</span>
                        <a href="https://www.youtube.com/watch?v=U02t54Wa45o&t=3s" target='_blank' rel="noopener noreferrer">
                            Ver entrevista
                            <span className={styles.arrowIcon}>&rarr;</span>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Prensa